import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { LoadingIconComponent } from '../../../app/content/layout/components/general/loading-icon/loading-icon.component';

const meta: Meta<LoadingIconComponent> = {
  title: 'Atoms/Loading/LoadingIcon',
  component: LoadingIconComponent,
  parameters: {
    docs: {
      description: {
        component: 'A animated loading icon component with wine glass animation. Used to indicate loading states.',
      },
    },
  },
  argTypes: {
    grey: {
      control: { type: 'boolean' },
      description: 'Whether to display the grey variant of the loading icon',
    },
    small: {
      control: { type: 'boolean' },
      description: 'Whether to display the small variant of the loading icon',
    },
  },
};

export default meta;
type Story = StoryObj<LoadingIconComponent>;

export const Default: Story = {
  args: {
    grey: false,
    small: false,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-loading-icon')).toBeTruthy();
  },
};

export const Grey: Story = {
  args: {
    grey: true,
    small: false,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-loading-icon')).toBeTruthy();
  },
};

export const Small: Story = {
  args: {
    grey: false,
    small: true,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-loading-icon')).toBeTruthy();
  },
};

export const SmallGrey: Story = {
  args: {
    grey: true,
    small: true,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-loading-icon')).toBeTruthy();
  },
};

export const AllVariants: Story = {
  render: () => ({
    template: `
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; max-width: 600px;">
        <div style="text-align: center;">
          <h4>Default</h4>
          <app-loading-icon></app-loading-icon>
        </div>
        <div style="text-align: center;">
          <h4>Grey</h4>
          <app-loading-icon [grey]="true"></app-loading-icon>
        </div>
        <div style="text-align: center;">
          <h4>Small</h4>
          <app-loading-icon [small]="true"></app-loading-icon>
        </div>
        <div style="text-align: center;">
          <h4>Small Grey</h4>
          <app-loading-icon [grey]="true" [small]="true"></app-loading-icon>
        </div>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'A showcase of all available loading icon variants.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelectorAll('app-loading-icon').length).toBe(4);
  },
};
